import * as React from 'react';

import { Switch } from '@rematter/ui-web';

import { useTranslations } from '../i18n/useTranslations';

interface TouchModeSwitch {
  touchModeEnabled: boolean;
  onChange: (value: boolean) => void;
}

export const TouchModeSwitch: React.FC<TouchModeSwitch> = ({
  touchModeEnabled,
  onChange,
}) => {
  const t = useTranslations();

  return (
    <div className="@TouchModeSwitch rounded-md border border-neutral/10 bg-neutral/5 px-3 py-2">
      <Switch
        isSelected={touchModeEnabled === true}
        onChange={(isSelected: boolean) => {
          onChange(isSelected);
        }}
        className="flex items-center gap-2"
      >
        <span>{t.touchModeSwitch.label} </span>
      </Switch>
    </div>
  );
};
